import React from 'react';

import {
  ColourPicker,
  Panel,
  Label,
  FormGroup,
  Flex,
  InfoSection,
  Divider,
  Accordion,
  Button
} from '@sopranodesign/pulse-components';
import { defaultTheme } from '@sopranodesign/pulse-volt';

import { useBotSettings } from '../../hooks/index';
import ColourContrast from '../ColourContrast';

const { gradient } = defaultTheme;

const FullPageColourSettings = () => {
  const {
    settings,
    setSettings,
    focusBanner,
    handleColourChangeNested
  } = useBotSettings();

  const handleReset = () => {
    setSettings(settings => ({
      ...settings,
      styles: {
        ...settings.styles,
        gradient: {
          from: gradient.from,
          to: gradient.to
        }
      }
    }));
  };

  const isSettingDefault = () => {
    return (
      settings.styles.gradient.from === gradient.from &&
      settings.styles.gradient.to === gradient.to
    );
  };

  return (
    <Flex>
      <Panel>
        <InfoSection
          mtNone
          title="Colours"
          info="Edit the colour scheme of your bot."
        />
        <Divider />

        <Flex col ySpace>
          <Accordion
            header="Background colours"
            primary
          >
            <FormGroup>
              <Flex mbSm between middle>
                <Label mb={false}>
                  Gradient start colour
                </Label>

                <ColourContrast
                  backgrounds={[
                    settings.styles.gradient.from
                  ]}
                  foreground="white"
                />
              </Flex>

              <ColourPicker
                testId="gradient-start-colour-picker"
                onChange={focusBanner}
                color={settings.styles.gradient.from}
                onChangeComplete={handleColourChangeNested(
                  'gradient',
                  'from'
                )}
              />
            </FormGroup>

            <FormGroup>
              <Flex mbSm between middle>
                <Label mb={false}>
                  Gradient end colour
                </Label>

                <ColourContrast
                  backgrounds={[
                    settings.styles.gradient.to
                  ]}
                  foreground="white"
                />
              </Flex>

              <ColourPicker
                testId="gradient-end-colour-picker"
                onChange={focusBanner}
                color={settings.styles.gradient.to}
                onChangeComplete={handleColourChangeNested(
                  'gradient',
                  'to'
                )}
              />
            </FormGroup>
          </Accordion>

          <Flex grow right>
            <Button
              selfBottom
              data-testid="bot-colour-defaults"
              variant="secondary"
              colour="danger"
              onClick={handleReset}
              disabled={isSettingDefault()}
            >
              Reset to default
            </Button>
          </Flex>
        </Flex>
      </Panel>
    </Flex>
  );
};

export default FullPageColourSettings;